import { createContext, useContext, useEffect, useState } from 'react'

export type ScrollOffsetContext = {
  top: number
}

export const ScrollOffset = createContext<ScrollOffsetContext>({
  top: 0,
})

export const useScrollOffset = (defaultScroll?: ScrollOffsetContext) => {
  const scrollOffset = useContext(ScrollOffset)
  const [top, setOffsetTop] = useState(0)
  const [localScrollOffset, setLocalScrollOffset] = useState<ScrollOffsetContext>(
    defaultScroll ?? scrollOffset
  )

  useEffect(() => {
    setLocalScrollOffset({
      ...localScrollOffset,
      top: scrollOffset.top + top,
    })
  }, [scrollOffset, top])

  return {
    scrollOffset,
    localScrollOffset,
    setOffsetTop,
  }
}
